import { Variation } from 'src/services/marketplace-api/dtos'
import { ProductCombinationAttributeSlug } from 'src/util/enums/product-combination-attribute-slug'
import {
  getSelectedVoltageFromAvailableVariations,
  isAttributeActive,
  treatedVoltageValue,
} from 'src/util/products'
import { AttributeProps, SelectProductAttributeType } from './types'

const makeOnAttributeClickEventHandler =
  (
    attribute: AttributeProps,
    slug: string,
    selectProductAttribute: SelectProductAttributeType,
    availableVariation?: Variation[]
  ) =>
  () => {
    if (isAttributeActive(attribute, slug)) return

    if (availableVariation?.length) {
      const selectedVoltage = getSelectedVoltageFromAvailableVariations(
        availableVariation,
        attribute
      )

      return selectProductAttribute(
        ProductCombinationAttributeSlug.Voltage,
        attribute.slug,
        selectedVoltage
      )
    }

    selectProductAttribute(
      ProductCombinationAttributeSlug.Color,
      attribute.slug
    )
  }

export const mapToProductAttributeButton = (
  attribute: AttributeProps,
  slug: string,
  selectProductAttribute: SelectProductAttributeType,
  availableVariation?: Variation[]
) => ({
  active: isAttributeActive(attribute, slug),
  attribute: {
    slug: attribute.slug,
    value: treatedVoltageValue(attribute?.valor),
  },
  available: attribute.available,
  handleOnClickEvent: makeOnAttributeClickEventHandler(
    attribute,
    slug,
    selectProductAttribute,
    availableVariation
  ),
})
